import { Link, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toggleSidebar } from '../features/uiSlice';
import { Home, GalleryVerticalEnd, Bookmark, Menu } from 'lucide-react';
import styles from '../css/MobileNavbar.module.css';

const MobileNavbar = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const isActive = (path) => location.pathname === path;

  const hideOnPaths = ['/login', '/register'];
  if (hideOnPaths.includes(location.pathname)) {
    return null;
  }

  return (
    <nav className={styles.mobileNavbar}>
      <Link to="/" className={`${styles.navItem} ${isActive('/') ? styles.active : ''}`}>
        <Home />
        <span>Главная</span>
      </Link>

      <Link to="/catalog" className={`${styles.navItem} ${isActive('/catalog') ? styles.active : ''}`}>
        <GalleryVerticalEnd />
        <span>Каталог</span>
      </Link>

      <Link to="/bookmarks" className={`${styles.navItem} ${isActive('/bookmarks') ? styles.active : ''}`}>
        <Bookmark />
        <span>Мое</span>
      </Link>

      <button className={styles.navItem} onClick={() => dispatch(toggleSidebar())}>
        <Menu />
        <span>Еще</span>
      </button>
    </nav>
  );
};

export default MobileNavbar;
